import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NotifierService } from 'angular-notifier';
import { ApiService } from 'src/app/services/api.service';
import { ErrorHelper } from '../common/ErrorHelper';
import { ThemePalette } from '@angular/material/core';
export interface LogLine {
  timestamp: Date;
  status: string;
  context: string;
  message: string;
}
@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss']
})
export class LogsComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['timestamp', 'status', 'context', 'message'];
  dataSource: MatTableDataSource<LogLine> = new MatTableDataSource<LogLine>();
  pageIndex: number = 0;
  pageSize: number = 20;
  totalLength: number = 10 * this.pageSize;
  loading: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('scrollContainer') private myScrollContainer: Element;

  constructor(
    private apiService: ApiService,
    private notifierService: NotifierService
  ) { }

  ngOnInit(): void {
    this.loadDataAsync();
  }

  ngAfterViewInit(): void {
    // this.dataSource.paginator = this.paginator;
  }

  async loadDataAsync(): Promise<any> {
    this.loading = true;
    try {
      const logs = await this.loadLogLines(this.pageIndex, this.pageSize);
      this.dataSource.data = logs;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
      this.scrollToTop();
    }
  }

  loadLogLines(pageIndex: number, pageSize: number): Promise<LogLine[]> {
    return new Promise<LogLine[]>((resolve, reject) => {
      this.apiService.getLogLines(pageIndex, pageSize).toPromise().then((logs) => {
        console.log('Fetched log lines:', logs);
        resolve(logs);
      }).catch(error => {
        const errorMessage = ErrorHelper.disectError('load log lines', error);
        this.notifierService.notify('error', errorMessage);
        reject(error);
      });
    });
  }

  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadDataAsync();
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}